module.exports = __webpack_public_path__ + "Bg_reports_Fall.00d5ddbbcf7bc77e1dfad118353b6c9d.png";